'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponsiveCarousel = exports.ResponsiveCarouselUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Media = require('decorators/Media/Media');

var _Media2 = _interopRequireDefault(_Media);

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

var _ResponsiveCarouselSm = require('./ResponsiveCarouselSm');

var _ResponsiveCarouselLg = require('./ResponsiveCarouselLg');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResponsiveCarouselUnwrapped = exports.ResponsiveCarouselUnwrapped = function (_Component) {
  (0, _inherits3.default)(ResponsiveCarouselUnwrapped, _Component);

  function ResponsiveCarouselUnwrapped() {
    (0, _classCallCheck3.default)(this, ResponsiveCarouselUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (ResponsiveCarouselUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(ResponsiveCarouselUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(ResponsiveCarouselUnwrapped, [{
    key: 'onDwell',
    value: function onDwell() {
      var handleDwell = this.props.handleDwell;

      if (handleDwell) {
        handleDwell();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          extraClass = _props.extraClass,
          handleSlide = _props.handleSlide,
          header = _props.header,
          loading = _props.loading,
          mediaQueryLg = _props.mediaQueryLg;


      if (loading || !children || !children.length) {
        return false;
      }

      var CarouselComponent = mediaQueryLg ? _ResponsiveCarouselLg.ResponsiveCarouselLg : _ResponsiveCarouselSm.ResponsiveCarouselSm;

      return _react2.default.createElement(
        'div',
        { className: 'carousel--responsive' },
        header && _react2.default.createElement(
          'h4',
          { className: 'mb+' },
          header
        ),
        _react2.default.createElement(
          CarouselComponent,
          {
            extraClass: extraClass,
            loading: loading,
            handleSlide: handleSlide
          },
          children
        )
      );
    }
  }]);
  return ResponsiveCarouselUnwrapped;
}(_react.Component);

ResponsiveCarouselUnwrapped.propTypes = {
  children: _propTypes2.default.arrayOf(_propTypes2.default.element).isRequired,
  extraClass: _propTypes2.default.string,
  handleDwell: _propTypes2.default.func,
  handleSlide: _propTypes2.default.func,
  header: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  mediaQueryLg: _propTypes2.default.bool
};

var ResponsiveCarousel = exports.ResponsiveCarousel = (0, _Media2.default)((0, _TrackDwell2.default)(ResponsiveCarouselUnwrapped));